export const topics = [
  {
    id: "kitchen-ledger",
    title: "后厨账本",
    subtitle: "餐饮连锁的成本红线，压到了谁的身上",
    desc: "从回锅油到耗材报废，我们把连锁餐饮后厨里被指标扭曲的操作逐条梳理。多篇爆料指向同一件事：当成本被做成百分比，标准就会先失真。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20a%20stainless%20steel%20kitchen%20pass%20with%20clipboards%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=1100&height=720&seq=heian-topic-01-cover-2026&orientation=landscape",
    storyIds: ["chain-kitchen-oil", "consumable-rep-confession", "training-loan-trap"],
    updated: "2026-08-28",
    count: 3,
  },
  {
    id: "gray-water-level",
    title: "直播电商的灰色水位",
    subtitle: "数据、退货与结算之间那条看不见的线",
    desc: "开场的爆发力、次日退货率、最终结算额，三条曲线常常互相打架。这个专题记录那些被“做上去”的数字，以及背后成熟的分工。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20neon%20live%20studio%20desk%20with%20rising%20charts%20in%20darkness%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=1100&height=720&seq=heian-topic-02-cover-2026&orientation=landscape",
    storyIds: ["livestream-water-curve", "referral-fee-dark-pool"],
    updated: "2026-08-15",
    count: 2,
  },
  {
    id: "data-market",
    title: "数据黑市浮世绘",
    subtitle: "被复制、转手、遗忘的会员表格",
    desc: "很多泄漏不是被攻破，而是被“拿走”。这个专题从数据流向、权限管理与个人防护三个角度，还原一条被忽视的灰色链条。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20server%20room%20corridor%20with%20glowing%20cables%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=1100&height=720&seq=heian-topic-03-cover-2026&orientation=landscape",
    storyIds: ["member-data-triple-sale", "voluntary-overtime-system"],
    updated: "2026-07-20",
    count: 2,
  },
  {
    id: "invisible-clauses",
    title: "隐形条款档案馆",
    subtitle: "签下名字那一刻，你答应的到底是什么",
    desc: "违约金、账号归属、分期债权、内推付费——这些条款很少出现在签约当天的对话里。我们把它们一条条摊开，提醒后来人。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20investigative%20magazine%20illustration%20of%20a%20signature%20line%20and%20magnifying%20glass%20over%20contracts%2C%20muted%20warm%20palette%20of%20brick%20red%20amber%20and%20charcoal%2C%20grainy%20paper%20texture%2C%20dramatic%20side%20lighting%2C%20abstract%20documentary%20collage%2C%20no%20text%2C%20high%20detail&width=1100&height=720&seq=heian-topic-04-cover-2026&orientation=landscape",
    storyIds: ["mcn-hidden-penalty", "training-loan-trap", "referral-fee-dark-pool"],
    updated: "2026-08-24",
    count: 3,
  },
];